import { jsx as _jsx } from "react/jsx-runtime";
/**
 * ExternalLink icon component for the External Link action type in selectors and lists.
 */
import { ExternalLink } from "lucide-react";
/**
 * Icon component for the external link step type.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The ExternalLink icon from lucide-react
 */
export function Icon({ className }) {
    return _jsx(ExternalLink, { className: className });
}
//# sourceMappingURL=Icon.js.map